import React from 'react';
import { Redirect } from 'react-router-dom';
import { getUserDetails } from '../../../../common/utils/Persist';
import ROUTES from '../RouteConstants'

const PublicRoute = () => {
  const isLoggedIn = getUserDetails('uifReadable', false)
  const isNotAutenticated = isLoggedIn == false;

  if (!isNotAutenticated) {
    return <Redirect to={{ pathname: ROUTES.DASHBOARD }} />;
  }
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const redirectUrl = process.env.REACT_APP_AUTH_REDIRECT_URL;
  window.location.href = `${apiBaseUrl}?continue=${redirectUrl}`;
};

export default PublicRoute;
